var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base",style:([
    !_vm.backColor
      ? { 'background-color': 'transparent' }
      : { 'background-color': _vm.backColor },
  ])},[_c('div',{attrs:{"align":"center"}},[_vm._m(0),_c('div',{staticStyle:{"color":"white","font-size":"20px"}},[_vm._v(" "+_vm._s(_vm.vEntorno.textloading)+" ")])]),_c('div',{staticClass:"fondo"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading readaption"},[_c('div',{staticClass:"circulo2"}),_c('div',{staticClass:"circulo3"}),_c('div',{staticClass:"circulo4"})])
}]

export { render, staticRenderFns }